<template>
  <div class="menu-pagination">
    <ul class="pagination">
      <li @click.stop="changePage(minPage)">
        <router-link to="" :class="{selected: firstPageActive, 
          otherpage: !firstPageActive}">{{ minPage }}
        </router-link>
      </li>
      <li v-if="lessPage">...</li>

      <li v-if="twoPrevPage > minPage" @click.stop="changePage(twoPrevPage)">
        <router-link to="" class="otherpage" >{{ twoPrevPage }}</router-link>
      </li>
      <li v-if="previousPage > minPage" @click.stop="changePage(previousPage)">
        <router-link to="" class="otherpage" >{{ previousPage }}</router-link>
      </li>
      <li v-if="selectedPage != minPage && selectedPage != maxPage" @click.stop="changePage(selectedPage)">
        <router-link to="" :class="{selected: (!firstPageActive && !lastPageActive) }">
          {{ selectedPage }}
        </router-link>
      </li>
      <li v-if="nextPage < maxPage" @click.stop="changePage(nextPage)">
        <router-link class="otherpage"  to="">{{ nextPage }}</router-link>
      </li>
      <li v-if="twoNextPage < maxPage" @click.stop="changePage(twoNextPage)">
        <router-link class="otherpage"  to="">{{ twoNextPage }}</router-link>
      </li>
      <li v-if="morePage">...</li>
      <li v-if="maxPage > 1" @click.stop="changePage(maxPage)">
        <router-link to="" :class="{selected: lastPageActive,
          otherpage: !lastPageActive}">{{ maxPage }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "adx-paging",
  methods: {
    changePage (selected) {
      if (selected == this.$props.selectedPage) { 
        return
      }
      this.$emit('change-page', selected)
    },
  },
  props: {
    selectedPage: {
      type: Number,
      required: true
    },
    maxPage: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      minPage: 1
    }
  },
  computed: {
    nextPage() {
      return this.$props.selectedPage + 1
    },
    twoNextPage() {
      return this.$props.selectedPage + 2
    },
    previousPage() {
      return this.$props.selectedPage - 1
    },
    twoPrevPage() {
      return this.$props.selectedPage - 2
    },
    lessPage() {
      if (this.$props.selectedPage - 3 > this.$data.minPage) {
        return true
      } else {
        return false
      }
    },
    morePage() {
      if (this.$props.selectedPage + 3 < this.$props.maxPage) {
        return true
      } else {
        return false
      }
    },
    firstPageActive() {
      if (this.$props.selectedPage == this.$data.minPage) {
        return true
      }
      return false
    },
    lastPageActive() {
      if (this.$props.selectedPage == this.$props.maxPage) {
        return true
      }
      return false
    },
  }
}
</script>


<style lang="scss" scoped>
@import "./index.scss";
</style>
